import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { memo } from 'react';
import { CloseIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';
import { IActivity } from '~/utils/interface/activity';
import dayjs from 'dayjs';

type EditTaskDialogProps = {
  open: boolean;
  setOpen?: (open: boolean, data?: IActivity) => void;
  data: IActivity | null;
};

const DetailsActivity = (props: EditTaskDialogProps) => {
  //#region Destructuring Props
  //#endregion Destructuring Props
  //#region Declare Hook
  const { t } = useTranslation(['admin/job', 'admin/component']);
  //#endregion Declare Hook
  //#region Selector
  //#endregion Selector
  //#region Declare State
  //#endregion Declare State
  //#region Implement Hook

  //#endregion Implement Hook
  //#region Handle Function

  const headCells = [
    {
      id: 'name',
      label: t(`activity.name`),
    },
    {
      id: 'customer',
      label: t(`activity.oldValue`),
    },
    {
      id: 'status',
      label: t(`activity.newValue`),
    },
  ];

  const handleCancel = () => {
    if (props.setOpen) {
      props.setOpen(false);
    }
  };

  //#endregion Handle Function
  return (
    <Dialog open={props.open} onClose={() => handleCancel()} fullWidth maxWidth='md'>
      <DialogTitle>
        {t('activity.label')}
        <IconButton onClick={() => handleCancel()} className='absolute right-[10px] top-[10px]'>
          <CloseIcon className='w-[10px] h-[10px]' />
        </IconButton>
      </DialogTitle>
      <Box className='mb-[20px] ml-[30px]'>
        <Typography className='mb-[10px] text-[12px]'>{props.data?.note}</Typography>
        <Box className='mb-[10px] text-[12px] flex'>
          {t('activity.updatedBy')}
          <Typography className='ml-[5px] text-[12px]'>{props.data?.createdByAccount.companyAccount.name}</Typography>
        </Box>
        <Box className='text-[12px] flex'>
          {t('activity.updatedAt')}
          <Typography className='ml-[5px] text-[12px]'>
            {dayjs(props.data?.deletedAt).format('DD/MM/YYYY h:mm:ss a')}
          </Typography>
        </Box>
      </Box>
      {props.data?.detail?.data?.length ? (
        <DialogContent>
          <TableContainer component={Paper}>
            <Table
              sx={{
                minWidth: 650,
                border: '1px solid #E5EAEF',
              }}
              aria-label='simple table'
            >
              <TableHead>
                <TableRow
                  sx={{
                    '&:last-child td, &:last-child th': { borderBottom: 0 },
                    '& td, & th': { border: '1px solid #E5EAEF' },
                  }}
                >
                  {headCells.map((item, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        borderBottom: '1px solid #E5EAEF',
                      }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data?.detail?.data?.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{
                      '&:last-child td, &:last-child th': { borderBottom: 0 },
                      '& td, & th': { border: '1px solid #E5EAEF' },
                    }}
                  >
                    <TableCell component='th' scope='row'>
                      {row.name}
                    </TableCell>

                    <TableCell align='left'>
                      {row.oldValue && <Box dangerouslySetInnerHTML={{ __html: String(row.oldValue) }} />}
                    </TableCell>
                    <TableCell align='left'>
                      {row.newValue && <Box dangerouslySetInnerHTML={{ __html: String(row.newValue) }} />}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      ) : (
        <></>
      )}

      <DialogActions className='justify-end'></DialogActions>
    </Dialog>
  );
};

export default memo(DetailsActivity);
